(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallDetailController', PhoneCallDetailController);

    /* Added UIFormAccess, $filter
    PhoneCallDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck'];

    function PhoneCallDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck) {
    */
    PhoneCallDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PhoneCall', 'CloudPBX', 'PhoneCallStatus', 'AdvertisingSource', 'Employee', 'OfficePhone', 'Division', 'User', 'PhoneCallCheck', 'UIFormAccess', '$filter'];

    function PhoneCallDetailController($scope, $rootScope, $stateParams, previousState, entity, PhoneCall, CloudPBX, PhoneCallStatus, AdvertisingSource, Employee, OfficePhone, Division, User, PhoneCallCheck, UIFormAccess, $filter) {
        var vm = this;

        vm.phoneCall = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;
        calcTitle();

        var unsubscribe = $rootScope.$on('telestatApp:phoneCallUpdate', function(event, result) {
            vm.phoneCall = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function calcTitle() {
            var title = $filter('date')(vm.phoneCall.callTime, 'dd.MM.yy HH:mm') + " " + vm.phoneCall.callingCaption + " → " + vm.phoneCall.calledCaption;
            if (vm.phoneCall.calledEmployee != null) {
                title += " (" + vm.phoneCall.calledEmployee.division.name + ")";
            }
            vm.phoneCall.title = title;
        }

    }
})();
